var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heatTreatmentInquireResult container"},[_c('div',{staticClass:"px-0"},[_c('b-col',{staticClass:"px-0",attrs:{"cols":"12"}},[_c('div',{staticClass:"my-3"},[_c('b-table',{staticClass:"ht-inquery-result-table-detail",attrs:{"items":_vm.heatTreatmentInquireResultItem,"fields":_vm.heatTreatmentInquireResultFields,"no-border-collapse":_vm.noCollapse},scopedSlots:_vm._u([{key:"thead-top",fn:function(){return [_c('b-tr',[_c('b-th',{staticStyle:{"background-color":"#4b8c80","color":"#ffffff","border-color":"#4b8c80","font-family":"'dfyuanstd-w7'","font-size":"1.125rem"},attrs:{"colspan":"7"}},[_c('span',[_vm._v("查詢結果")])])],1)]},proxy:true}])})],1),_vm._v(" "),_c('div',{staticStyle:{"overflow-y":"auto","width":"100%","min-width":"900px","text-align":"right"}},[_c('exportCsv')],1),_vm._v(" "),(_vm.htWorkValueItem.length > 0)?_c('div',{staticClass:"my-3",staticStyle:{"overflow-y":"auto","height":"550px","width":"100%","min-width":"900px"}},[_c('table',{staticClass:"ht-work-value-table"},[_c('thead',{staticClass:"sticky-thead"},_vm._l((_vm.htWorkValueFields),function(item,index){return _c('th',{key:index,style:({
                'writing-mode':
                  item.key == 'time' ? 'horizontal-tb' : 'vertical-rl',
              })},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])}),0),_vm._v(" "),_vm._l((_vm.htWorkValueItem),function(item){return [_c('tr',[_c('td',{staticStyle:{"background-color":"#ffffff"},attrs:{"rowspan":"2"}},[_vm._v("\n                "+_vm._s(item.time)+"\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"70px"}},[_vm._v("設定值")]),_vm._v(" "),_vm._l((item.value.set),function(set_item,set_key){return _c('td',{key:set_key},[_vm._v("\n                "+_vm._s(set_item)+"\n              ")])})],2),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"min-width":"70px"}},[_vm._v("實際值")]),_vm._v(" "),_vm._l((item.value.act),function(act_item,act_key){return _c('td',{key:act_key,style:({
                  'background-color':
                    act_key == 'quench_furn_temp1' ||
                    act_key == 'quench_furn_temp2' ||
                    act_key == 'tempering_furn_temp1' ||
                    act_key == 'tempering_furn_temp2' ||
                    act_key == 'carb_tank_temp'
                      ? '#fff'
                      : item.value.set[act_key] > 100
                      ? item.value.set[act_key] + 30 < act_item ||
                        item.value.set[act_key] - 30 > act_item
                        ? '#c10000'
                        : item.value.set[act_key] + 15 < act_item ||
                          item.value.set[act_key] - 15 > act_item
                        ? '#ffc100'
                        : '#fff'
                      : item.value.set[act_key] < 1
                      ? item.value.set[act_key] + 0.1 < act_item ||
                        item.value.set[act_key] - 0.1 > act_item
                        ? '#c10000'
                        : item.value.set[act_key] + 0.05 < act_item ||
                          item.value.set[act_key] - 0.05 > act_item
                        ? '#ffc100'
                        : '#fff'
                      : item.value.set[act_key] + 20 < act_item ||
                        item.value.set[act_key] - 20 > act_item
                      ? '#c10000'
                      : item.value.set[act_key] + 10 < act_item ||
                        item.value.set[act_key] - 10 > act_item
                      ? '#ffc100'
                      : '#fff',
                  color:
                    act_key == 'quench_furn_temp1' ||
                    act_key == 'quench_furn_temp2' ||
                    act_key == 'tempering_furn_temp1' ||
                    act_key == 'tempering_furn_temp2' ||
                    act_key == 'carb_tank_temp'
                      ? '#4b8c80'
                      : item.value.set[act_key] > 100
                      ? item.value.set[act_key] + 30 < act_item ||
                        item.value.set[act_key] - 30 > act_item
                        ? '#fff'
                        : item.value.set[act_key] + 15 < act_item ||
                          item.value.set[act_key] - 15 > act_item
                        ? '#646569'
                        : '#4b8c80'
                      : item.value.set[act_key] < 1
                      ? item.value.set[act_key] + 0.1 < act_item ||
                        item.value.set[act_key] - 0.1 > act_item
                        ? '#fff'
                        : item.value.set[act_key] + 0.05 < act_item ||
                          item.value.set[act_key] - 0.05 > act_item
                        ? '#646569'
                        : '#4b8c80'
                      : item.value.set[act_key] + 20 < act_item ||
                        item.value.set[act_key] - 20 > act_item
                      ? '#fff'
                      : item.value.set[act_key] + 10 < act_item ||
                        item.value.set[act_key] - 10 > act_item
                      ? '#646569'
                      : '#4b8c80',
                })},[_vm._v("\n                "+_vm._s(act_item)+"\n              ")])})],2)]})],2)]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00480238","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/heatTreatmentInquireResult.vue
// module id = null
// module chunks = 